// 用户名正则
export const userNameRegExp = /^[a-zA-Z][a-zA-Z0-9]{3,19}$/

// 密码正则(必须同时保护数字和字母)
export const passwordRegExp = /^(?=.*[a-zA-Z])(?=.*\d).+$/

// 手机号正则
export const mobileRegExp = /^1[3456789]\d{9}$/

// 座机正则
export const telRegExp = /^([0-9]{3,4}-)?[0-9]{7,8}$/

// 邮箱校验(支持中文)
export const emailRegExp =
    /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/

// 邮编正则
export const postcodeExp = /\d{6}/

// 中国身份证号
// export const idNumberExp =
//     /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/

// IPV4
export const IPV4Exp = /^(\d{1,3}\.){3}\d{1,3}$/

// IPV6
export const IPV6Exp =
    /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/

// 域名
// export const domainExp = /^([0-9a-zA-Z-]{1,}\.)+([a-zA-Z]{2,})$/
export const domainExp =
    /^([0-9a-zA-Z\u4e00-\u9fa5-]{1,}\.)+([a-zA-Z\u4e00-\u9fa5]{2,})$/u

// www协议
export const wwwFrontExp = /^www\..+/

// 正则校验
export const regExpTest = (reg: RegExp, str: string): boolean => {
    return reg.test(str)
}

// 用户名校验
export const userNameTest = (str: string): boolean => {
    return regExpTest(userNameRegExp, str)
}

// 密码校验
export const passwordTest = (str: string): boolean => {
    return regExpTest(passwordRegExp, str)
}

// 手机号校验
export const mobileTest = (str: string): boolean => {
    return regExpTest(mobileRegExp, str)
}

// 座机校验
export const telTest = (str: string): boolean => {
    return regExpTest(telRegExp, str)
}

// 座机和手机号校验
export const telMobileTest = (str: string): boolean => {
    return mobileTest(str) || telTest(str)
}

// 邮箱校验
export const emailTest = (str: string): boolean => {
    return regExpTest(emailRegExp, str)
}

// 邮编校验
export const postcodeTest = (str: string): boolean => {
    return regExpTest(postcodeExp, str)
}

// 身份证号校验
// export const idNumberTest = (str: string): boolean => {
//     return regExpTest(idNumberExp, str)
// }

// IPv4校验
export const ipV4Test = (str: string): boolean => {
    return regExpTest(IPV4Exp, str)
}

// IPv6校验
export const ipV6Test = (str: string): boolean => {
    return regExpTest(IPV6Exp, str)
}

// 域名校验
export const domainTest = (str: string): boolean => {
    return regExpTest(domainExp, str)
}

/*
 * 身份证15位编码规则：dddddd yymmdd xx p
 * dddddd：6位地区编码
 * yymmdd: 出生年(两位年)月日，如：910215
 * xx: 顺序编码，系统产生，无法确定
 * p: 性别，奇数为男，偶数为女
 *
 * 身份证18位编码规则：dddddd yyyymmdd xxx y
 * dddddd：6位地区编码
 * yyyymmdd: 出生年(四位年)月日，如：19910215
 * xxx：顺序编码，系统产生，无法确定，奇数为男，偶数为女
 * y: 校验码，该位数值可通过前17位计算获得
 *
 * 前17位号码加权因子为 Wi = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ]
 * 验证位 Y = [ 1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2 ]
 * 如果验证码恰好是10，为了保证身份证是十八位，那么第十八位将用X来代替
 * 校验位计算公式：Y_P = mod( ∑(Ai×Wi),11 )
 * i为身份证号码1...17 位; Y_P为校验码Y所在校验码数组位置
 */
export const idNumberTest = (idCard: string): boolean => {
    //15位和18位身份证号码的正则表达式
    const regIdCard =
        /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/

    //如果通过该验证，说明身份证格式正确，但准确性还需计算
    if (regIdCard.test(idCard)) {
        if (idCard.length == 18) {
            const idCardWi = [
                7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2
            ] //将前17位加权因子保存在数组里
            const idCardY = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2] //这是除以11后，可能产生的11位余数、验证码，也保存成数组
            let idCardWiSum = 0 //用来保存前17位各自乖以加权因子后的总和
            for (let i = 0; i < 17; i++) {
                idCardWiSum += Number(idCard.substring(i, i + 1)) * idCardWi[i]
            }
            const idCardMod = idCardWiSum % 11 //计算出校验码所在数组的位置
            const idCardLast = idCard.substring(17) //得到最后一位身份证号码
            //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
            if (idCardMod == 2) {
                return idCardLast == 'X' || idCardLast == 'x'
            } else {
                //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
                return idCardLast == String(idCardY[idCardMod])
            }
        } else {
            return false
        }
    } else {
        return false
    }
}

// www协议校验
export const wwwFrontTest = (str: string): boolean => {
    return regExpTest(wwwFrontExp, str)
}
